import { useState } from "react";

const CheckBoxHookForm = ({
  name = "text-name",
  type = "checkbox",
  className,
  label,
  register,
  validation,
  onClick,
  disabled = false,
}) => {
  const [focus, setFocus] = useState(false);

  return (
    <input
      type={type}
      name={name}
      label={label}
      className={`${className} cursor-pointer hover:cursor-pointer`}
      disabled={disabled}
      {...register(name, validation)}
      onClick={onClick}
      onFocus={() => {
        setFocus(true);
      }}
    />
  );
};
export default CheckBoxHookForm;
